import React, { Component } from 'react';
import { reduxForm, Field } from 'redux-form/immutable';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';

import './auth.css';
import misc from '../../misc';
import ForgotPasswordConfirm from './ForgotPasswordConfirm';

export class ForgotPassword extends Component {
  render() {
    if (this.props.submitSucceeded === true) {
      return <ForgotPasswordConfirm />;
    }

    const { handleSubmit, pristine, submitting, error } = this.props;

    return (
      <div className="container">
        <div className="row justify-content-md-center">
          <div className="col-md-6">
            <form onSubmit={handleSubmit(this.props.onSubmit)}>
              <div className="text-center m-4">
                <img
                  src={misc.images.logoGrey3}
                  width="30"
                  height="30"
                  className="d-inline-block align-top"
                  alt="Federation"
                />
                <h2 className="mb-1 d-inline-block align-bottom">
                  &nbsp;Reset Password
                </h2>
              </div>

              {error && <misc.components.Alert message={error} />}

              <Field
                component={misc.components.FormField}
                name="email"
                id="email"
                type="email"
                label="Email address"
                required
                autoFocus
              />
              <misc.components.LoadingButton
                className="btn-lg"
                disabled={pristine || submitting}
                loading={this.props.isLoading}
              >
                Reset Password
              </misc.components.LoadingButton>
              <div className="text-center mt-3">
                Know your password? <Link to="/auth/login">Login</Link>
              </div>
            </form>
          </div>
        </div>
      </div>
    );
  }
}

ForgotPassword.propTypes = {
  errorMessage: PropTypes.string,
  isError: PropTypes.bool,
  isLoading: PropTypes.bool,
  onSubmit: PropTypes.func.isRequired
};

ForgotPassword.defaultProps = {
  isLoading: false,
  isError: false,
  errorMessage: 'Sorry, an error occurred.'
};

export function validate(values) {
  const errors = {};

  // Email
  if (!values.get('email')) {
    errors.email = true;
  } else if (!misc.lib.validators.validateEmail(values.get('email'))) {
    errors.email = 'Email address is invalid';
  }

  return errors;
}

export default reduxForm({
  validate,
  form: 'forgotPasswordForm'
})(ForgotPassword);



// WEBPACK FOOTER //
// ./src/modules/auth/components/ForgotPassword.js